<template>
  <div class="wrapped-static divfix" v-if="show">
    <v-progress-circular
      :value="porcentaje"
      color="primary"
      :size="300"
      pt-7
      :width="30"
    >
      <h1>{{ value }}/{{ total }}</h1></v-progress-circular
    >
  </div>
</template>

<script>
export default {
  props: ["show", "value", "total"],
  computed: {
    porcentaje() {
      return Math.floor((100 / this.total) * this.value);
    }
  }
};
</script>
<style>
.wrapped-static {
  max-width: 100%;
  min-width: 100%;

  max-height: 100%;
  min-height: 100%;
}
.divfix {
  bottom: 15;
  right: 0;

  position: fixed;
  z-index: 3000;
}
</style>
